import Cookies from 'js-cookie';
import get from 'lodash/get';

let omniture = omnitureIsOnPage() ? window.tm_omn : {};

function getPrefix () {
  // Country codes can be set with the omniture.prefix property
  const prefix = get(window, 'settings.tracking.omniture.prefix');

  if (typeof prefix !== 'undefined') {
    return prefix + ': ';
  }

  return '';
}

function omnitureIsOnPage () {
  return typeof get(window, 'tm_omn.tl') === 'function';
}

function omnitureIsEnabled () {
  if (omnitureIsOnPage()) {
    return get(window.settings, 'tracking.omniture.isEnabled', false);
  }

  return false;
}

function getDefaultOptions () {
  return {
    prefix:            true,
    sendAutomatically: true,
    // If set parameters in the send() call should only be sent once to omniture, used for click tracking
    sendOnce:          false
  };
}

function getUrlParameter (name) {
  const results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(window.location.href);

  if (!results) {
    return false;
  }

  return results[1] || false;
};

function clearConstiables (omniture) {
  for (let i = 0; i < 75; i++) {
    omniture['prop' + i] = '';
    omniture['econst' + i] = '';
  }
}

function clearLabels (omniture) {
  const sconstArr = [
    'channel',
    'products',
    'events',
    'campaign',
    'purchaseID',
    'state',
    'zip',
    'server',
    'linkName'
  ];

  return sconstArr.forEach(key => {
    omniture[key] = '';
  });
}

/**
 * Sets a single constiable on the omniture object. The object key should be the omniture
 * value to set, while the value can either be the value directly, or an object. If the
 * value is an object, value.value will be set on the omniture object, while the other
 * properties can be used to configure it. Currently we only support prefixed: false,
 * which disables the default behaviour of prefixing Omniture constiables with a region.
 *
 * @param {string} constiable constiable name
 * @param {*} value Either a primitive value, or an object with value configuration
 * @returns {*}
 */
function setconstiable (constiable, value) {
  if (typeof value !== 'string') return;

  omniture.linkTrackconsts = getLinkTrackConstants(constiable);
  omniture[constiable] = getOmnitureValue(constiable, value);

  return omniture[constiable];
}

function getLinkTrackConstants (constiable) {
  const linkTrackconsts = get(omniture, 'linkTrackconsts');

  if (typeof linkTrackconsts === 'undefined' || linkTrackconsts === 'None') {
    return constiable;
  }
  else if (get(omniture, 'linkTrackconsts', '').indexOf(constiable) === -1) {
    return omniture.linkTrackconsts + ',' + constiable;
  }

  return omniture.linkTrackconsts;
}

function getOmnitureValue (constiable, value) {
  let shouldPrefix  = getDefaultOptions().prefix;
  let omnitureValue = get(value, 'value', value);

  // Currently, the only available configuration is disabling prefixing
  if (value.prefix === false) {
    shouldPrefix = false;
  }

  if (shouldPrefix === true && constiableShouldBePrefixed(constiable)) {
    omnitureValue = getPrefix() + omnitureValue;
  }

  // Actually sets the constiable
  omniture[constiable] = omnitureValue;
  if (omniture.linkTrackconsts) {
    omniture['linkTrackVars'] = omniture.linkTrackconsts;
  }

  return omnitureValue;
}

/**
 * Checks if a omniture constiable should be prefixed or not
 *
 * @param {string} value The omniture constiable name
 * @returns {boolean}
 */
function constiableShouldBePrefixed (value) {
  // Properties added here needs to be added in OmnitureModule.php as well
  const vals = [
    'channel',
    'pageName',
    'prop1',
    'prop2',
    'prop3',
    'prop4',
    'prop14',
    'prop16',
    'econst2',
    'econst3',
    'econst14',
    'econst29'
  ];

  return vals.indexOf(value) !== -1;
};

function setconstiables (data) {
  return Object.keys(data).forEach(key => setconstiable(key, data[key]));
};

function unsetconstiables (data) {
  return Object.keys(data).forEach(key => delete omniture[key]);
};

function sendToOmniture () {
  if (!omnitureIsEnabled()) return false;

  setconstiable('prop13', getUserInfo());
  setconstiable('econst21', getBrandInfo());

  const prop14 = getUrlParameter('tm_link');

  if (prop14 !== false) {
    setconstiable('prop14', prop14);
  }

  return tryToCallOmniture();
};

function getBrandInfo () {
  const hasBrand = (Cookies.get('brand') && Cookies.get('brand').length > 0);
  return hasBrand ? Cookies.get('brand') : '';
}

function getUserInfo () {
  const hasUserInfo = Cookies.get('userinfo') && Cookies.get('userinfo').length > 0;
  return hasUserInfo ? 'Logged In' : 'Not Logged In';
}

function tryToCallOmniture () {
  if (typeof omniture.tl === 'function') {
    omniture.tl(true, 'o', 'Send to Omniture');
  }

  return omniture;
}

function send (data, newOptions) {
  if (!omnitureIsEnabled()) return false;

  const options             = getDefaultOptions();
  options.prefix            = get(newOptions, 'prefix', true);
  options.sendAutomatically = get(newOptions, 'sendAutomatically', true);
  options.sendOnce          = get(newOptions, 'sendOnce', false);

  setconstiables(data);

  if (options.sendAutomatically) {
    sendToOmniture();
  }

  if (options.sendOnce) {
    unsetconstiables(data);
  }

  return true;
};

function sendSingle (data) {
  const cacheTracking = Object.assign({}, omniture);
  clearConstiables(omniture);
  clearLabels(omniture);
  send(data, {sendAutomatically: true, sendOnce: true});
  omniture = cacheTracking;
};

export default  {
  sendSingle:     sendSingle,
  send:           send,
  sendToOmniture: sendToOmniture
};



// WEBPACK FOOTER //
// ./frontend/react/utils/omniture-helper/index.js